import { object, array, number, boolean } from '@gogame/schemas';

import {
  EVENT,
  APPLICATION,
  NETWORK,
  AFFILIATES,
  CAMPAIGNS,
  REG_PLATFORM,
  EVENT_PLATFORM,
  TRAFFIC_TYPE,
  IS_INCLUDE_REJECTED_REGS,
  SENDING_DELAY,
  IS_ACTIVE,
  ACTIVITY_TYPE,
  TRAFFIC_TYPE_ALL,
  ACTIVITY_TYPE_ALL,
  REGISTRATION_COUNTRIES,
  EVENT_COUNTRIES,
  CHANNELS,
} from './constants';

export const conversionSchema = object({
  [EVENT]: number().required('Event is required'),
  [APPLICATION]: number().required('Application is required'),
  [NETWORK]: number().nullable(),
  [AFFILIATES]: array(number()),
  [CHANNELS]: array(number()),
  [CAMPAIGNS]: array(number()),
  [REG_PLATFORM]: number().nullable(),
  [EVENT_PLATFORM]: number().nullable(),
  [TRAFFIC_TYPE]: number().nullable().default(TRAFFIC_TYPE_ALL),
  [ACTIVITY_TYPE]: number().nullable().default(ACTIVITY_TYPE_ALL),
  [IS_INCLUDE_REJECTED_REGS]: boolean().nullable(),
  [SENDING_DELAY]: number().default(0),
  [IS_ACTIVE]: boolean().default(true),
  [REGISTRATION_COUNTRIES]: array(number()),
  [EVENT_COUNTRIES]: array(number()),
});
